import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { CalendarLocalizedMessagesDirective } from '@progress/kendo-angular-dateinputs';
import { AssetsFleetManagementRoutingModule } from './assets-fllet-management-routing.module';
import { AssetsFleetManagementListComponent } from './assets-fleet-management-list/assets-fleet-management-list.component';
import { AssetsFleetManagementViewComponent } from './assets-fleet-management-list/assets-list-view/assets-fleet-management-view.component';

@NgModule({
  declarations: [AssetsFleetManagementListComponent, AssetsFleetManagementViewComponent],
  imports: [
    CommonModule,
    AssetsFleetManagementRoutingModule,
    TranslateModule.forChild(),
    InputsModule,
    FormsModule,
    ComponentsModule,
    PipeModule,
    CalendarLocalizedMessagesDirective,
  ],
})
export class AssetsFleetManagementModule {}
